import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, keywords, canonicalUrl }) => {
  return (
    <Helmet>
      {/* Primary SEO Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {/* Google no longer uses the meta keywords tag for ranking, but you can include it for your own reference or very specific use cases. */}
      {/* <meta name="keywords" content={keywords} /> */}

      {/* Open Graph tags for social media sharing previews */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:keywords" content={keywords} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />

      {/* Canonical tag to prevent duplicate content issues */}
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEO;
